import { useState } from "react";
import { postCloneBetweenDocumentsURL } from "../../utils/ConstantsURL";

export const useCloneDocuments = () => {
  const [loading, setLoading] = useState(false);
  const [clonedSections, setClonedSections] = useState([]);

  const executeFullClonation = async (token, documentOrigin, documentTarget, date) => {
    if (!token || !documentOrigin || !documentTarget) {
      return { success: false, error: "Faltan datos requeridos" };
    }

    setLoading(true);
    setClonedSections([]);

    try {
      const response = await fetch(postCloneBetweenDocumentsURL(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          documentOrigin: Number(documentOrigin),
          documentTarget: Number(documentTarget),
          date: date
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || data.message || `Error ${response.status}: Error en el servidor`);
      }

      const sections = data.clonedSectionsOfTargetDocument || [];
      const mappedSections = sections.map(s => ({
        id: s.sectionId || s.id,
        name: s.sectionName || s.name
      }));

      setClonedSections(mappedSections);
      return { success: true, sections: mappedSections, details: data.details || [] };

    } catch (err) {
      console.error('[Clonación Error]:', err);
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  };

  return { executeFullClonation, loading, clonedSections };
};